import { motion } from "framer-motion";

const fade = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
};

export default function Challenge() {
  return (
    <section id="challenge" data-testid="challenge-section" className="py-32 lg:py-40 bg-muted/60">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-16">
        <div className="lg:col-span-6">
          <motion.p {...fade} transition={{ duration: 0.6, ease: "easeOut" }} className="text-xs md:text-sm tracking-[0.25em] uppercase font-bold text-accent">
            The Challenge
          </motion.p>
          <motion.h2 {...fade} transition={{ duration: 0.6, delay: 0.1, ease: "easeOut" }} className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-none mt-6">
            Technology changes fast. People and organizations need help <span className="italic text-primary">keeping up.</span>
          </motion.h2>
        </div>
        <div className="lg:col-span-5 lg:col-start-8">
          <motion.div {...fade} transition={{ duration: 0.6, delay: 0.15, ease: "easeOut" }} className="space-y-6 text-base sm:text-lg leading-relaxed font-light text-foreground/80">
            <p>Buying new technology is easy.</p>
            <p>
              Getting employees, educators, and leaders to understand it, trust it,
              and actually use it well is much harder.
            </p>
            <p>Phillip helps organizations close that gap.</p>
            <p>
              His professional development programs combine technology expertise,
              practical demonstrations, hands-on learning, and more than three
              decades of experience teaching people at every skill level.
            </p>
            <p>
              Participants don't simply hear about technology.
            </p>
            <p className="font-display text-2xl sm:text-3xl text-foreground font-medium">
              They learn how to use it.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
